export enum Environments {
  PROD = 'production',
  DEV = 'development',
  LOCAL = 'local',
}
